import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingActions from "@/components/FloatingActions";
import useSEO from "@/hooks/useSEO";

export default function PageShell({ eyebrow, title, intro, children, testId, seo }) {
  useSEO(seo || {});
  return (
    <div data-testid={testId}>
      <Header />
      <main className="bg-white">
        <section className="bg-[#F4F9FC] border-b border-[#E5E5E5]">
          <div className="max-w-5xl mx-auto px-6 lg:px-8 py-20 lg:py-28">
            <div className="text-[11px] uppercase tracking-[0.22em] text-[#D4AF37] font-semibold">{eyebrow}</div>
            <h1 className="font-heading mt-3 text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-[#0A0A0A]">
              {title}
            </h1>
            {intro && <p className="mt-5 text-[#4B5563] text-base lg:text-lg leading-relaxed max-w-2xl">{intro}</p>}
          </div>
        </section>
        <section className="py-16 lg:py-24">
          <div className="max-w-4xl mx-auto px-6 lg:px-8 prose prose-neutral max-w-none">
            {children}
          </div>
        </section>
      </main>
      <Footer />
      <FloatingActions />
    </div>
  );
}
